import React, { useState, useEffect } from 'react'
import SubHeader from '../general/SubHeader'
import Course1 from '../assets/ach-1.jpg';
import AddDialog from '../general/AddDialog';
import ScrollAnimation from 'react-animate-on-scroll';


const OurAchievements = ({ setResponse, setLoading }) => {
  const [showAch, setShowAch] = useState(false);
  const [achieve, setAchieve] = useState([]);

  useEffect(() => {
    const fetchAchievement = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcian.in/get-achievement');

        if (response.ok) {
          const data = await response.json();
          data.sort((a, b) => new Date(b.date) - new Date(a.date));
          setAchieve(data);
          setLoading(false);
        } else {
          setLoading(false);
          console.error('Failed to fetch coupon');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };
    fetchAchievement();
  }, []);

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  const allAchievements = achieve.filter((ach) => ach.category == 'All')
  const studyAchievements = achieve.filter((ach) => ach.category == 'Study')

  return (
    <>
      {/* <SubHeader message="Achievements" /> */}
      <ScrollAnimation animateIn='fadeInUp'>
        <div className='safely-measures1'>
          <h2 >ACHIEVEMENTS</h2>
          <p>"KC Public School takes pride in the remarkable achievements of our students and faculty. From academic excellence to sports, arts, and cultural activities, <br></br>every milestone reflects our commitment to nurturing talent, inspiring growth, and celebrating success at every step."</p>

        </div>
      </ScrollAnimation>

      <section className='my-5'>
        <div className='container'>

          <div className='text-end'>
            <button className='carousel-btn text-nowrap' onClick={() => setShowAch(true)} style={{backgroundColor:"#FF9149"}}>Add Achievement <i class="fa-solid fa-graduation-cap"></i></button></div>


          {studyAchievements.length > 0 ? (
            <>
              {allAchievements
                .filter(ach => ach.category == 'All').map(ach => (
                  <div className='achievement-area1 my-3'>
                    <div className='row'>

                      <div className='col-lg-3 col-12'>
                        <img src={`https://api.kcian.in/uploads/${ach.image}`} className='img-fluid w-100' alt='achievements' /></div>

                      <div className='col-lg-8 col-12 my-2 align-content-center'>
                        <p className='fw-bold fs-5 mb-0'>{ach.tagline}</p>
                        <p className='text-muted para-text'>Posted On: {formatDateTime(ach.posted_on)} by {ach.added_by}<br /> {ach.batch ? <>Batch: {ach.batch}</> : null}</p>
                        <p className='text-muted'>{ach.description}</p>
                      </div>

                    </div>
                  </div>
                ))}



              <p className='about-heading mt-5'>Studies & Activity</p>
              <hr className='slider-hr mb-4' />


              {studyAchievements
                .filter(ach => ach.category == 'Study').map(ach => (
                  <div className='achievement-area1 my-3'>
                    <div className='row'>

                      <div className='col-lg-3 col-12'>
                        <img src={`https://api.kcian.in/uploads/${ach.image}`} className='img-fluid w-100' alt='achievements' /></div>

                      <div className='col-lg-8 col-12 my-2 align-content-center'>
                        <p className='fw-bold fs-5 mb-0'>{ach.tagline}</p>
                        <p className='text-muted para-text'>Posted On: {formatDateTime(ach.posted_on)} by {ach.added_by}<br /> {ach.batch ? <>Batch: {ach.batch}</> : null}</p>
                        <p className='text-muted'>{ach.description}</p>
                      </div>

                    </div>
                  </div>
                ))}
            </>
          ) : (
            <div className='achievement-area1 my-3'>
              <div className='row'>

                <div className='col-lg-3 col-12'>
                  <img src={Course1} className='img-fluid w-100' alt='achievements' /></div>

                <div className='col-lg-8 col-12 my-2 align-content-center'>
                  <p className='fw-bold fs-5 mb-0'>The School has achieved SCHOOL EXCELLENCE AWARD thrice</p>
                  <p className='text-muted para-text'>Posted On: 27 Jan 2025 12:11 am by School</p>
                  <p className='text-muted'>Our school has proudly received this excellence award three times, recognizing the outstanding commitment to academic quality, innovation, and holistic student development.</p>
                </div>

              </div>
            </div>
          )}

        </div>
      </section>



      {showAch && <AddDialog setShowAch={setShowAch} setResponse={setResponse} setLoading={setLoading} />}


    </>
  )
}

export default OurAchievements
